module.exports = "/_next/static/images/payroll-financing-9697d6be866f8edbcfccaa3195e32b3f.svg";